import React from 'react';
import { HiOutlineChip, HiOutlineCloud, HiOutlineServer, HiOutlineShare } from 'react-icons/hi';
import Reveal from './ui/Reveal';
import SectionHeading from './ui/SectionHeading';

const focusAreas = [
    { icon: HiOutlineShare, title: 'Graph RAG Pipelines', text: 'Retrieval over vector and graph databases like Memgraph.' },
    { icon: HiOutlineChip, title: 'LLM Orchestration', text: 'Agents and pipelines built with LangChain and modern LLMs.' },
    { icon: HiOutlineServer, title: 'Distributed Backends', text: 'RESTful microservices in Java, Spring Boot and Go.' },
    { icon: HiOutlineCloud, title: 'Cloud-Native on AWS', text: 'Production-grade, reliable systems designed to scale.' },
];

const About = () => {
    return (
        <section name='about' className='relative w-full py-24 sm:py-32 border-t border-slate-800/60'>
            <div className='max-w-[1160px] w-full mx-auto px-6 sm:px-8'>
                <SectionHeading eyebrow="About" title="Building reliable systems for AI and the cloud" />

                <div className='grid lg:grid-cols-[1.1fr_1fr] gap-12 items-start'>
                    <Reveal className='space-y-5 text-base sm:text-lg text-slate-400 leading-relaxed'>
                        <p>
                            Hi, I'm Sharvan. I am a Software Developer with a strong background in distributed systems and expertise
                            in <span className="text-slate-200 font-medium">Python, LLMs, LangChain, Java, Spring Boot, Go, and AWS</span>.
                        </p>
                        <p>
                            I specialize in building scalable backend systems, Graph RAG pipelines, and intelligent cloud-native applications.
                            With hands-on experience in designing robust architectures, developing RESTful APIs, and integrating vector/graph databases (<span className="text-slate-200 font-medium">Memgraph</span>) and modern LLM orchestration frameworks, I focus on creating efficient, reliable, and production-grade software solutions.
                        </p>
                    </Reveal>

                    <div className='grid sm:grid-cols-2 gap-4'>
                        {focusAreas.map(({ icon: Icon, title, text }, i) => (
                            <Reveal key={title} delay={i * 0.06}>
                                <div className='card h-full p-5 hover:border-slate-700 transition-colors'>
                                    <Icon size={22} className='text-[#64ffda] mb-4' aria-hidden="true" />
                                    <h3 className='text-slate-100 font-semibold mb-1.5'>{title}</h3>
                                    <p className='text-sm text-slate-400 leading-relaxed'>{text}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
